export { SecurityPage as default } from '@/components/enpages/Legal/SecurityPolicy'
